import React from 'react';
import { Button, Form, Select } from 'antd';
import { ArrowDownIcon, TimerIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { IOlympicList, useOlympicCourse, useOlympicOrder } from 'modules/online-olympic';

import TimerBox from '../timer-box';

interface IProps {
  olympic?: IOlympicList;
}

const { useForm, useWatch } = Form;

const Dtm: React.FC<IProps> = ({ olympic }) => {
  const t = useTranslations();
  const [form] = useForm();
  const { olympicCourse, isLoading } = useOlympicCourse();
  const { mutate, isLoading: isOrdering } = useOlympicOrder();
  const selectedCourseId = useWatch('olympicCourseId', form);

  const selectedCourse = olympicCourse?.find(course => course.id === selectedCourseId);

  const onFinish = (values: { olympicCourseId?: number }) => {
    mutate(values);
  };

  return (
    <div className="flex flex-col items-center gap-y-3 md:flex-row md:gap-3">
      <div className="min-h-65 w-full rounded-xl bg-white p-4 sm:mx-0">
        <div className="flex items-center justify-between">
          <div className="inline rounded-lg bg-red-50 p-2 text-sm font-medium text-red-500">
            {olympic?.required_subjects?.length} {t('ta_majburiy_fanlar')}
          </div>
        </div>
        <div className="mt-5 rounded-lg bg-gray-50 p-2 font-medium">
          <div className="flex items-center justify-between">
            <p className="font-semibold">{t('fanlar')}</p>
            <p className="text-sm text-gray-700">{t('savollar_soni')}</p>
          </div>
          <hr className="!my-2 border-gray-200 bg-gray-50" />
          <div className="space-y-1 text-sm">
            {olympic?.required_subjects?.map(subject => (
              <div key={subject?.id} className="flex items-center justify-between">
                <p className="text-gray-800">{subject?.name}</p>
                <p className="text-gray-700">
                  {subject?.question_count} {t('ta')}
                </p>
              </div>
            ))}
          </div>
        </div>
        <TimerBox status={olympic?.status} time={olympic?.end_time} />
      </div>
      <div className="min-h-65 w-full rounded-xl bg-white p-4 sm:mx-0">
        {!olympic?.already_participated ? (
          <>
            <div className="flex items-center justify-between">
              <div className="inline rounded-lg bg-green-50 p-2 text-sm font-medium text-green-500">
                2 {t('ta_asosiy_fanlar')}
              </div>
            </div>
            <p className="mt-3 text-lg font-medium">{t('fanlar_majmuasini_tanlash')}</p>
            <Form form={form} onFinish={onFinish}>
              <Form.Item
                layout="vertical"
                label={<label className="mb-0 block text-gray-800">{t('fanlar_majmuasi')}</label>}
                name="olympicCourseId"
                className="!mb-13 !mt-5"
              >
                <Select
                  suffixIcon={<ArrowDownIcon />}
                  allowClear
                  placeholder={t('Fan')}
                  loading={isLoading}
                  options={
                    olympicCourse?.map(d => ({
                      value: d.id,
                      label: d.name
                    })) || []
                  }
                />
              </Form.Item>
              {selectedCourse && (
                <div className=" flex items-center justify-between">
                  <div className="flex items-center gap-1 font-semibold">
                    <div className="text-indigo-600">
                      <TimerIcon />
                    </div>
                    {selectedCourse?.duration} {t('daqiqa')}
                  </div>
                  <Button
                    loading={isOrdering}
                    htmlType="submit"
                    className="!rounded-lg !border-transparent !bg-green-500 !py-4 !text-white disabled:!bg-gray-100 disabled:!text-gray-400"
                  >
                    {t('boshlash')}
                  </Button>
                </div>
              )}
            </Form>
          </>
        ) : null}
        {olympic?.already_participated ? (
          <p className="text-sm text-gray-600">
            {t(
              'siz_allaqachon_ushbu_olimpiadada_qatnashgansiz_iltimos_natijalarni_korish_uchun_olimpiada_tugashini_kuting'
            )}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default Dtm;
